import { render, staticRenderFns } from "./order-form-property-hair-texture.vue?vue&type=template&id=683e70df&scoped=true"
import script from "./order-form-property-hair-texture.vue?vue&type=script&lang=js"
export * from "./order-form-property-hair-texture.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-hair-texture.vue?vue&type=style&index=0&id=683e70df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e70df",
  null
  
)

export default component.exports